import { CartConstantsEnum } from '@commerce-cart-webcomponents/sdk';

export const LocalStorageKeys = {
  WAREHOUSE_ID: 'warehouseId',
  CHECKOUT_PROFILE: 'checkoutProfile',
  SHARECODE_ATTRIBUTES: 'sharecodeAttributes',
  CART_ID: CartConstantsEnum.CartId,
  CART_REQ_VERSION: CartConstantsEnum.CartReqVersion,
  NOTIFICATION_VERSION_NUMBER: 'notificationVersionNumber',
};
export enum UrlKeyEnum {
  CO_APPLICANT = '/co-applicant',
}

export const SessionStorageKeys = {
  SHARE_CHANNEL_CONFIG: 'shareChannelConfig',
};

export enum LinkQueryParamsEnum {
  abo = 'abo',
  lang = 'lang',
}
